import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckoutActions } from "../actions";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import { switchMap, map, catchError, of, takeUntil } from "rxjs";
import { pDropdown } from "../../../../SGRE-shared/models/primeng.model";
import { LoggerService, Occ, tryNormalizeHttpError } from "@spartacus/core";

@Injectable()
export class CheckoutCountriesEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions$: Actions,
        private apiService: ApiService,
    ) { }

    loadCountries$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.loadCountries),
            switchMap(() => this.apiService.getCountries()
                .pipe(
                    takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                    map(data => {
                        const payload: pDropdown[] = data?.countries
                            .filter((country: any) => country.name)
                            .map((country: any) => ({ label: country.name, value: country.isocode }));
                        return CheckoutActions.loadCountriesSuccess({ payload });
                    }),
                    catchError(error => of(CheckoutActions.loadCountriesFail({
                        payload: tryNormalizeHttpError(error, this.logger)
                    })))
                )
            )
        )
    );

    loadRegion$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.loadRegion),
            switchMap(({ payload }) =>
                this.apiService.getRegion(payload)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map((data: Occ.RegionList) => {
                            const payload: pDropdown[] = data?.regions
                                .filter((region: any) => !!region.name)
                                .map((region: any) => ({ label: region.name, value: region.isocode }));
                            return CheckoutActions.loadRegionSuccess({ payload })
                        }),
                        catchError(error => of(CheckoutActions.loadRegionFail({
                            payload: tryNormalizeHttpError(error, this.logger)
                        })))
                    )
            )
        )
    );
}